import PropTypes from "prop-types"
import { InputLabel, IconButton, Alert } from "@mui/material"
import { Clear } from "@mui/icons-material"
import { get } from "lodash"

function getSelectedInstrumentDescription(instrument = {}) {
  const { id, ticker, mic, type, assetClass, assetSubclass, description } = instrument
  if (assetClass === "swap") {
    return `Basket: ${get(instrument, "ticker")}`
  } else if (type === "portfolio") {
    return `Portfolio${description ? `: ${description}` : ""}`
  } else if (type === "benchmark") {
    return `Benchmark: ${id}`
  } else if (type === "index") {
    return `Index: ${id}`
  } else if (assetSubclass === "etf") {
    return `ETF${ticker ? `: ${ticker}.${mic}` : ""}`
  }
  return ""
}

function BetaInstrument({ betaInstrument, clear }) {
  const { name, isUnavailable, isUnmodeled, isPermissionDenied } = betaInstrument || {}
  const isInvalidInstrument = isUnavailable || isUnmodeled || isPermissionDenied
  let invalidReason
  if (isUnavailable) {
    invalidReason = "This instrument is not available under the selected model"
  } else if (isUnmodeled) {
    invalidReason = "This instrument is not modeled under the selected model"
  } else {
    invalidReason = "You do not have permission to view this instrument"
  }

  return <div className="selected-instrument-wrapper">
    <InputLabel disableAnimation shrink>
      Beta Instrument
    </InputLabel>
    {isInvalidInstrument && <Alert className="selected-instrument-invalid" severity="warning">
      <div>{invalidReason}</div>
    </Alert>}
    <div className="selected-instrument-field">
      <div className="selected-instrument">
        <div className="name">
          {name}
        </div>
        <div className="subtext">
          {getSelectedInstrumentDescription(betaInstrument)}
        </div>
      </div>
      <IconButton className="remove-instrument" onClick={() => clear()} size="large">
        <Clear />
      </IconButton>
    </div>
  </div>
}

BetaInstrument.propTypes = {
  betaInstrument: PropTypes.object.isRequired,
  clear: PropTypes.func.isRequired,
}

export default BetaInstrument
